import { isInEnum } from '../../common';
import { PERIOD_TYPE } from '../constants';
import {
  isBlockingUrlParametersOnClicks,
  isBlockingUrlParametersOnInApp,
  isValidationUrlParametersOnClicks,
  isValidationUrlParametersOnInApp,
} from '../guards/fraud.guard';
import { FraudConfig, FraudIpClickCappingConfig } from '../models/fraud-config.model';

/** Devuelve string con el error o null */
export const validateFraudConfigIpClickCapping = (config: FraudIpClickCappingConfig): string | null => {
  if (config.maxNumberClicks <= 0) {
    return 'maxNumberCliks must be an integer greather than 0';
  }
  if (!isInEnum(PERIOD_TYPE, config.time)) {
    return 'time value is not valid';
  }
  return null;
};

/** Limpia los arrays de fraudConfigs para ahorrar espacio */
export const sanitizeFraudConfig = (fraudConfigs: FraudConfig[]): FraudConfig[] => {
  return fraudConfigs.filter((fraudConfig) => {
    if (!fraudConfig.isEnabled) {
      return false;
    }
    if (
      (isValidationUrlParametersOnClicks(fraudConfig) ||
        isBlockingUrlParametersOnClicks(fraudConfig) ||
        isValidationUrlParametersOnInApp(fraudConfig) ||
        isBlockingUrlParametersOnInApp(fraudConfig)) &&
      !fraudConfig.parameters.length
    ) {
      return false;
    }
    return true;
  });
};
